// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 320px) and (max-width: 767px) {
  .paynowbtn {
    width: 100% !important;
    margin: 12px 0 !important;
  }

  .paynowsec {
    display: block !important;
  }

  .homepage {
    height: 100% !important;
  }

  .Auth-size {
    min-width: 100% !important;
    padding: 0 0 !important;
  }

  .logindiv {
    max-width: 300px !important;
    margin: 0 auto !important;
  }
}

@media only screen and (min-width: 767px) and (max-width: 9927px) {
  .paynowbtn p {
    padding: 13px 0 14px !important;
    width: 160px !important;
  }
}

.gradient-form {
  background-color: #42c1f4;
  height: 100vh;
  justify-content: center;
  display: flex;
  align-items: center;
}

.Auth-size {
  margin: 0 auto;
  max-width: 362px;
  min-width: 363px;
}

.Auth-button {
  border-radius: 5px;
  padding: 0.375rem 0.75rem;
  border: none;
  color: white;
  background: #7867c1;
  width: 100%;
  height: 35px;
  margin-bottom: 10px;
  font-weight: 300;
  font-size: 14px;
  margin-top: 15px;
  font-family: "Poppins";
}

.auth-divide-section {
  display: flex;
  gap: 13px;
}

.Auth-size-register {
  max-width: 550px;
  margin: 0 auto !important;
}

.inputCntnr {
  width: 100%;
  margin-top: 0px;
}

.inputCntnrMobile {
  width: 50%;
}

/* Thank you and Verify-email page  css start */

.thankyoupage {
  background: #42c1f4;
}

.login-content-registering {
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 90%;
}

.thanktext {
  padding: 25px 25px 25px;
  width: 100%;
  border: 1px solid #0d6efd00;
  border-radius: 8px;
  box-shadow: 0px 1px 5px #0d6efd45;
  background: #fff;
}

.logo-content {
  text-align: center;
  margin: 10px 0 20px;
}

.thanktext p {
  line-height: 28px;
  text-align: center;
  padding: 15px 0;
  font-size: 16px;
}

form.loginpgae {
  padding: 15px;
  margin: 25px;
}

form.loginpgae input {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  font-size: 15px;
  width: 90%;
}

form.loginpgae label {
  font-size: 18px;
  font-weight: 500;
}

/* Thank you and Verify-email page  css end */

.logindiv {
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);
  border-radius: 10px !important;
}

h2.titlewelcome {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 33px;
  color: #000000;
  margin-bottom: 0;
  margin-top: 5px;
}

form.loginpgae label {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  text-align: center;
  color: #000000;
}

.text-login {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 20px;
  color: #000;
}

.form-control:focus {
  border-color: #00a2fd;
  outline: 0;
  box-shadow: unset;
}

a.Create-account-btn {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  font-size: 14px;
  height: 35px;
  color: #000;
  margin: 8px 0 9px;
  font-family: "Poppins";
  width: 100%;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  display: flex;
}

a.hover-primary {
  color: #7867c1;
  font-size: 14px;
  text-decoration: none;
  font-weight: 400;
  margin-top: 7px;
  display: inline-block;
  text-transform: capitalize;
  font-family: "Poppins";
}

.Registerpage {
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);
  border-radius: 10px;
}

h2.signtitle {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 33px;
  color: #000000;
  text-align: center;
  margin-top: 2px;
}

p.create-text {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #000000;
  margin-bottom: 20px;
}

.Createpagebtn {
  margin-top: 10px;
  width: 100%;
}

.accounttext p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #000;
}

.accounttext a {
  font-family: "Poppins";
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #7867c1;
  text-decoration: none;
}

.accounttext {
  margin-bottom: 6px;
}

.Account-sec {
  text-align: center;
}

.forgotpage {
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);
  border-radius: 10px;
}

h2.forgottext {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 33px;
  color: #000000;
  text-align: center;
  margin: 7px 0 30px;
}

h3.verifytitle {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 33px;
  color: #000000;
  text-align: center;
  margin: 7px 0 20px;
}

a.cancel-forgotbtn {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  font-size: 14px;
  height: 35px;
  color: #000;
  margin: 8px 0 9px;
  font-family: "Poppins";
  width: 100%;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  display: flex;
}

.forgotsendbtn {
  margin: 10px 0 0;
}

.section-2 {
  margin: 8px 0 8px;
}

.error input {
  border: 1px solid #d35662 !important;
  background: #faeff0 !important;
}

.error label {
  color: #d35662 !important;
}

.Resetpage {
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);
  border-radius: 10px !important;
}

h2.Reset-password {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 33px;
  color: #000000;
  margin-top: 6px;
  text-align: center;
  margin-bottom: 40px;
  text-transform: capitalize;
}

.Resetpass a {
  color: #000;
  text-transform: uppercase;
  font-size: 14px;
  text-decoration: none;
  font-weight: 400;
  font-family: "Poppins";
}

.Resetpass p {
  font-size: 14px;
  font-weight: 400;
  font-family: "Poppins";
}

.thankyoudiv {
  text-align: center;
}

a.successfullyButton:hover {
  color: #fff;
}

.cms-logo {
  text-align: center;
  margin-top: 0px;
}

img.cms-login-logo {
  max-width: 170px;
  margin: 0 auto;
}

img.login-sidebar-img {
  width: 148px;
}

.notifican-left-Sec {
  width: 80%;
}

.notifican-Sec {
  display: flex;
  padding: 0 46px;
}

.notifican-Right-Sec {
  width: 20%;
}

.notifican-Right-Sec ul {
  padding: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  margin: 0;
}

.notifican-Right-Sec li {
  list-style: none;
  margin: 0 9px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
}

.notifican-Right-Sec li:hover {
  background: #fff0f4;
  border-radius: 100px;
  width: 45px;
  height: 45px;
  margin: 0 9px;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: 2s;
}

body::-webkit-scrollbar {
  width: 0px;
}

body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

img.logo-thankyou {
  width: 250px;
  margin: 0 auto;
}
img.payImg {
  width: 65px;
  margin: 0 auto;
}

a.successfullyButton3 {
  border-radius: 5px;
  padding: 13px 0;
  border: none;
  color: white;
  background: #7867c1;
  width: 100% !important;
  font-weight: 300;
  font-size: 14px;
  margin-top: 0;
  font-family: "Poppins";
  display: inline-block;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
}

.successfullyButton2 {
  border-radius: 5px;
  padding: 13px 0;
  border: none;
  color: white;
  background: #7867c1;
  width: 100% !important;
  font-weight: 300;
  font-size: 14px;
  margin-top: 0;
  font-family: "Poppins";
  display: inline-block;
  text-decoration: none;
  text-align: center;
  cursor: pointer;
}

.register a {
  border: 1px solid;
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  padding: 6px 0;
  border-radius: 6px;
  cursor: pointer;
}

.Forgotsec a {
  border: 1px solid;
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  padding: 6px 0;
  border-radius: 6px;
  cursor: pointer;
}

form.loginpgae input {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  font-size: 15px;
  width: 100%;
  padding: 8px 2px;
}

.inputCntnr2 {
  margin-top: 10px;
}

h3.success {
  text-align: center;
}

a.loginbtnbuttom {
  width: 100%;
  display: flex;
  justify-content: center;
  border: 1px solid #ddd;
  padding: 9px 0;
  border-radius: 5px;
  margin-top: 6px;
  cursor: pointer;
}

.paynowbtn p {
  background: #7867c1;
  color: #fff;
  padding: 13px 0 14px;
  border-radius: 7px;
  width: 200px;
  margin: 0 auto 8px;
  cursor: pointer;
}

.successbtnpaypage {
  width: 200px;
  border: none;
  background: #7867c1;
  color: #fff;
  padding: 13px 0;
  border-radius: 10px;
  margin-top: 30px;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 12px;
}

.paynowsec {
  width: 90%;
  margin: 0 auto;
  display: flex;
}

.paynowbtn {
  width: 33.33%;
  background: #fff;
  margin: 12px;
  text-align: center;
  padding: 50px 0;
  border-radius: 15px;
}

.homepage {
  background: #42c1f4;
  padding: 40px 0;
}

.HomepageMain.d-flex {
  display: flex;
  justify-content: space-between;
}

.d-flex.align-items-center.justify-content-center.pb-4.accounttext {
  display: flex;
  justify-content: center;
}

a.loginbtnbuttom {
  width: 100%;
  display: flex;
  justify-content: center;
  border: 1px solid #ddd;
  padding: 9px 5px;
  border-radius: 5px;
  margin-top: 6px;
  cursor: pointer;
  margin-left: 8px;
}
p.Subscription {
  color: #fff;
  text-align: center;
  margin: 4px 0 20px;
  font-size: 32px;
  font-weight: 600;
  font-family: poppins;
}
.thanktext h3 {
  font-size: 22px;
  padding: 10px 0;
  font-weight: bold;
  color: #000;
  text-align: center;
}
.thankyoudiv a {
  border: none;
  width: 150px !important;
}
.accounttext p {
  display: flex;
  align-items: center;
  font-size: 15px;
}

.login-card-centered {
  background: #fff;
  max-width: 500px;
  margin: 40px auto;
  padding: 40px 32px 32px 32px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loginpgae {
  width: 100%;
}

.cms-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}

.cms-login-logo {
  width: 200px;
  max-width: 170px;
  display: block;
  margin: 0 auto 18px auto;
}

.titlewelcome {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0;
}

.text-login {
  text-align: center;
  margin-bottom: 24px;
  color: #222;
}

.inputCntnr {
  width: 100%;
  margin-bottom: 16px;
}

.inputCntnr input.form-control {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 1rem;
}

.Auth-button {
  width: 100%;
  background: #7a6fc1;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 0;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 16px;
  transition: background 0.2s;
}

.Auth-button:hover {
  background: #5d54a4;
}

.register,
.Forgotsec {
  width: 100%;
  text-align: center;
  margin: 8px 0;
}

.hover-primary {
  color: #7a6fc1;
  text-decoration: underline;
  font-weight: 500;
  transition: color 0.2s;
}

.hover-primary:hover {
  color: #42c1f4;
}
`, "",{"version":3,"sources":["webpack://./src/pages/auth/login.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,uBAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,+CAA+C;;AAE/C;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6CAA6C;;AAE7C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EAEE,YAAY;EAGZ,uBAAuB;AAFzB;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@media only screen and (min-width: 320px) and (max-width: 767px) {\n  .paynowbtn {\n    width: 100% !important;\n    margin: 12px 0 !important;\n  }\n\n  .paynowsec {\n    display: block !important;\n  }\n\n  .homepage {\n    height: 100% !important;\n  }\n\n  .Auth-size {\n    min-width: 100% !important;\n    padding: 0 0 !important;\n  }\n\n  .logindiv {\n    max-width: 300px !important;\n    margin: 0 auto !important;\n  }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 9927px) {\n  .paynowbtn p {\n    padding: 13px 0 14px !important;\n    width: 160px !important;\n  }\n}\n\n.gradient-form {\n  background-color: #42c1f4;\n  height: 100vh;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.Auth-size {\n  margin: 0 auto;\n  max-width: 362px;\n  min-width: 363px;\n}\n\n.Auth-button {\n  border-radius: 5px;\n  padding: 0.375rem 0.75rem;\n  border: none;\n  color: white;\n  background: #7867c1;\n  width: 100%;\n  height: 35px;\n  margin-bottom: 10px;\n  font-weight: 300;\n  font-size: 14px;\n  margin-top: 15px;\n  font-family: \"Poppins\";\n}\n\n.auth-divide-section {\n  display: flex;\n  gap: 13px;\n}\n\n.Auth-size-register {\n  max-width: 550px;\n  margin: 0 auto !important;\n}\n\n.inputCntnr {\n  width: 100%;\n  margin-top: 0px;\n}\n\n.inputCntnrMobile {\n  width: 50%;\n}\n\n/* Thank you and Verify-email page  css start */\n\n.thankyoupage {\n  background: #42c1f4;\n}\n\n.login-content-registering {\n  max-width: 500px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 90%;\n}\n\n.thanktext {\n  padding: 25px 25px 25px;\n  width: 100%;\n  border: 1px solid #0d6efd00;\n  border-radius: 8px;\n  box-shadow: 0px 1px 5px #0d6efd45;\n  background: #fff;\n}\n\n.logo-content {\n  text-align: center;\n  margin: 10px 0 20px;\n}\n\n.thanktext p {\n  line-height: 28px;\n  text-align: center;\n  padding: 15px 0;\n  font-size: 16px;\n}\n\nform.loginpgae {\n  padding: 15px;\n  margin: 25px;\n}\n\nform.loginpgae input {\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n  font-size: 15px;\n  width: 90%;\n}\n\nform.loginpgae label {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n/* Thank you and Verify-email page  css end */\n\n.logindiv {\n  background: #ffffff;\n  border: 1px solid #efefef;\n  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);\n  border-radius: 10px !important;\n}\n\nh2.titlewelcome {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 33px;\n  color: #000000;\n  margin-bottom: 0;\n  margin-top: 5px;\n}\n\nform.loginpgae label {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 15px;\n  text-align: center;\n  color: #000000;\n}\n\n.text-login {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: center;\n  margin-bottom: 20px;\n  color: #000;\n}\n\n.form-control:focus {\n  border-color: #00a2fd;\n  outline: 0;\n  box-shadow: unset;\n}\n\na.Create-account-btn {\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n  font-size: 14px;\n  height: 35px;\n  color: #000;\n  margin: 8px 0 9px;\n  font-family: \"Poppins\";\n  width: 100%;\n  text-decoration: none;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n\na.hover-primary {\n  color: #7867c1;\n  font-size: 14px;\n  text-decoration: none;\n  font-weight: 400;\n  margin-top: 7px;\n  display: inline-block;\n  text-transform: capitalize;\n  font-family: \"Poppins\";\n}\n\n.Registerpage {\n  background: #ffffff;\n  border: 1px solid #efefef;\n  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);\n  border-radius: 10px;\n}\n\nh2.signtitle {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 33px;\n  color: #000000;\n  text-align: center;\n  margin-top: 2px;\n}\n\np.create-text {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  text-align: center;\n  color: #000000;\n  margin-bottom: 20px;\n}\n\n.Createpagebtn {\n  margin-top: 10px;\n  width: 100%;\n}\n\n.accounttext p {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  text-align: center;\n  color: #000;\n}\n\n.accounttext a {\n  font-family: \"Poppins\";\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  text-align: center;\n  color: #7867c1;\n  text-decoration: none;\n}\n\n.accounttext {\n  margin-bottom: 6px;\n}\n\n.Account-sec {\n  text-align: center;\n}\n\n.forgotpage {\n  background: #ffffff;\n  border: 1px solid #efefef;\n  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);\n  border-radius: 10px;\n}\n\nh2.forgottext {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 33px;\n  color: #000000;\n  text-align: center;\n  margin: 7px 0 30px;\n}\n\nh3.verifytitle {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 33px;\n  color: #000000;\n  text-align: center;\n  margin: 7px 0 20px;\n}\n\na.cancel-forgotbtn {\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n  font-size: 14px;\n  height: 35px;\n  color: #000;\n  margin: 8px 0 9px;\n  font-family: \"Poppins\";\n  width: 100%;\n  text-decoration: none;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n}\n\n.forgotsendbtn {\n  margin: 10px 0 0;\n}\n\n.section-2 {\n  margin: 8px 0 8px;\n}\n\n.error input {\n  border: 1px solid #d35662 !important;\n  background: #faeff0 !important;\n}\n\n.error label {\n  color: #d35662 !important;\n}\n\n.Resetpage {\n  background: #ffffff;\n  border: 1px solid #efefef;\n  box-shadow: 0px 4px 6px rgb(0 0 0 / 25%);\n  border-radius: 10px !important;\n}\n\nh2.Reset-password {\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 33px;\n  color: #000000;\n  margin-top: 6px;\n  text-align: center;\n  margin-bottom: 40px;\n  text-transform: capitalize;\n}\n\n.Resetpass a {\n  color: #000;\n  text-transform: uppercase;\n  font-size: 14px;\n  text-decoration: none;\n  font-weight: 400;\n  font-family: \"Poppins\";\n}\n\n.Resetpass p {\n  font-size: 14px;\n  font-weight: 400;\n  font-family: \"Poppins\";\n}\n\n.thankyoudiv {\n  text-align: center;\n}\n\na.successfullyButton:hover {\n  color: #fff;\n}\n\n.cms-logo {\n  text-align: center;\n  margin-top: 0px;\n}\n\nimg.cms-login-logo {\n  max-width: 170px;\n  margin: 0 auto;\n}\n\nimg.login-sidebar-img {\n  width: 148px;\n}\n\n.notifican-left-Sec {\n  width: 80%;\n}\n\n.notifican-Sec {\n  display: flex;\n  padding: 0 46px;\n}\n\n.notifican-Right-Sec {\n  width: 20%;\n}\n\n.notifican-Right-Sec ul {\n  padding: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  margin: 0;\n}\n\n.notifican-Right-Sec li {\n  list-style: none;\n  margin: 0 9px;\n  width: 45px;\n  height: 45px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  cursor: pointer;\n}\n\n.notifican-Right-Sec li:hover {\n  background: #fff0f4;\n  border-radius: 100px;\n  width: 45px;\n  height: 45px;\n  margin: 0 9px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  transition: 2s;\n}\n\nbody::-webkit-scrollbar {\n  width: 0px;\n}\n\nbody::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\nimg.logo-thankyou {\n  width: 250px;\n  margin: 0 auto;\n}\nimg.payImg {\n  width: 65px;\n  margin: 0 auto;\n}\n\na.successfullyButton3 {\n  border-radius: 5px;\n  padding: 13px 0;\n  border: none;\n  color: white;\n  background: #7867c1;\n  width: 100% !important;\n  font-weight: 300;\n  font-size: 14px;\n  margin-top: 0;\n  font-family: \"Poppins\";\n  display: inline-block;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n}\n\n.successfullyButton2 {\n  border-radius: 5px;\n  padding: 13px 0;\n  border: none;\n  color: white;\n  background: #7867c1;\n  width: 100% !important;\n  font-weight: 300;\n  font-size: 14px;\n  margin-top: 0;\n  font-family: \"Poppins\";\n  display: inline-block;\n  text-decoration: none;\n  text-align: center;\n  cursor: pointer;\n}\n\n.register a {\n  border: 1px solid;\n  width: 100%;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  padding: 6px 0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.Forgotsec a {\n  border: 1px solid;\n  width: 100%;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  padding: 6px 0;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\nform.loginpgae input {\n  background: #ffffff;\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n  font-size: 15px;\n  width: 100%;\n  padding: 8px 2px;\n}\n\n.inputCntnr2 {\n  margin-top: 10px;\n}\n\nh3.success {\n  text-align: center;\n}\n\na.loginbtnbuttom {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  border: 1px solid #ddd;\n  padding: 9px 0;\n  border-radius: 5px;\n  margin-top: 6px;\n  cursor: pointer;\n}\n\n.paynowbtn p {\n  background: #7867c1;\n  color: #fff;\n  padding: 13px 0 14px;\n  border-radius: 7px;\n  width: 200px;\n  margin: 0 auto 8px;\n  cursor: pointer;\n}\n\n.successbtnpaypage {\n  width: 200px;\n  border: none;\n  background: #7867c1;\n  color: #fff;\n  padding: 13px 0;\n  border-radius: 10px;\n  margin-top: 30px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n\n.paynowsec {\n  width: 90%;\n  margin: 0 auto;\n  display: flex;\n}\n\n.paynowbtn {\n  width: 33.33%;\n  background: #fff;\n  margin: 12px;\n  text-align: center;\n  padding: 50px 0;\n  border-radius: 15px;\n}\n\n.homepage {\n  background: #42c1f4;\n  padding: 40px 0;\n}\n\n.HomepageMain.d-flex {\n  display: flex;\n  justify-content: space-between;\n}\n\n.d-flex.align-items-center.justify-content-center.pb-4.accounttext {\n  display: flex;\n  justify-content: center;\n}\n\na.loginbtnbuttom {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  border: 1px solid #ddd;\n  padding: 9px 5px;\n  border-radius: 5px;\n  margin-top: 6px;\n  cursor: pointer;\n  margin-left: 8px;\n}\np.Subscription {\n  color: #fff;\n  text-align: center;\n  margin: 4px 0 20px;\n  font-size: 32px;\n  font-weight: 600;\n  font-family: poppins;\n}\n.thanktext h3 {\n  font-size: 22px;\n  padding: 10px 0;\n  font-weight: bold;\n  color: #000;\n  text-align: center;\n}\n.thankyoudiv a {\n  width: 200px;\n  border: none;\n}\n.thankyoudiv a {\n  width: 150px !important;\n}\n.accounttext p {\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n}\n\n.login-card-centered {\n  background: #fff;\n  max-width: 500px;\n  margin: 40px auto;\n  padding: 40px 32px 32px 32px;\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.loginpgae {\n  width: 100%;\n}\n\n.cms-logo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.cms-login-logo {\n  width: 200px;\n  max-width: 170px;\n  display: block;\n  margin: 0 auto 18px auto;\n}\n\n.titlewelcome {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.text-login {\n  text-align: center;\n  margin-bottom: 24px;\n  color: #222;\n}\n\n.inputCntnr {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.inputCntnr input.form-control {\n  width: 100%;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  font-size: 1rem;\n}\n\n.Auth-button {\n  width: 100%;\n  background: #7a6fc1;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 16px;\n  transition: background 0.2s;\n}\n\n.Auth-button:hover {\n  background: #5d54a4;\n}\n\n.register,\n.Forgotsec {\n  width: 100%;\n  text-align: center;\n  margin: 8px 0;\n}\n\n.hover-primary {\n  color: #7a6fc1;\n  text-decoration: underline;\n  font-weight: 500;\n  transition: color 0.2s;\n}\n\n.hover-primary:hover {\n  color: #42c1f4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
